module.exports = "//public.zight.com/packs/media/images/cloudapp-5c0ee14cddcd744c496ca1c877342562.png";